export default __webpack_public_path__ + "static/media/webTraderIcon1.93849211.webp";